import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  Space,
  Form,
  Input,
  DatePicker,
  Select,
  Table,
  notification,
  Spin,
  message,
  Checkbox
} from "antd";
import {
  SearchOutlined
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import moment from "moment";
import util from "helpers/util";
import { saveAs } from "file-saver";
import stockAdjustment from "constants/api/stockAdjustment";

export default function DraftList({ editDraftFromList }) {

  const dateFormat = "YYYY-MM-DD";
  const { RangePicker } = DatePicker;

  const [formTakeList] = Form.useForm();

  const [isLoadingTbDraftList, setIsLoadingTbDraftList] = useState(false);
  const [rowsDraftList, setRowsDraftList] = useState([]);
  const [tbUSListSearchText, setTbStockTakeListSearchText] = useState("");
  const [tbUSListSearchedColumn, setTbStockTakeListSearchedColumn] = useState("");
  const [selectedRowKeysDraftList, setSelectedRowKeysDraftList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const tbStockTakeListSearchInput = useRef(null);

  const [creationDate, setCreationDate] = useState([]);
  const [dateValue, setDateValue] = useState([]);
  const [limitDays, setLimitDays] = useState(0);

  const [draftNumbersFetch, setDraftNumbersFetch] = useState([]);
  const urlDetail = util.getCurrentUrlDetail();
  const decodePath = decodeURIComponent(urlDetail.subPath ?? "");

  useEffect(() => {
    if (decodePath == "draft") {
      setIsLoadingTbDraftList(true)
      const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
      const endOfMonth = moment().endOf('month').format('YYYY-MM-DD');
      stockAdjustment.getDraftList(startOfMonth, endOfMonth)
        .then((res) => {
          if (res.success) {
            let newRows = [];
            let dataDraftNumbers = [];

            if (res.success) {
              res.result.sort(function (a, b) {
                return moment(b.creationTime).unix() - moment(a.creationTime).unix();
              });
              res.result.map((row, index) => {
                newRows.push({
                  //key: index + 1,
                  //key: row.draftNumber,
                  key: row.id,
                  index: index + 1,
                  draftNumber: row.draftNumber,
                  store: row.store,
                  creatorUser: row.creatorUser,
                  creationTime: util.formatNullableDatetime(row.creationTime)
                });

                if (!dataDraftNumbers.some(x => x == row.draftNumber)) {
                  dataDraftNumbers.push(row.draftNumber);
                }
              });

              setRowsDraftList(newRows);
              setDraftNumbersFetch(dataDraftNumbers);
              //setSelectedRowKeysDraftList(newRows.map((item) => item.key));
            }

            setIsLoadingTbDraftList(false);
          }
          else {
            notification.error({
              message: "Error",
              description: res.message,
              duration: 0,
            });

            setIsLoadingTbDraftList(false);
          }
        })
        .catch((err) => {
          notification.error({
            message: "Internal server error. please contact administrator",
            duration: 0,
          });
          setIsLoadingTbDraftList(false);
        });

    }
  }, [])

  const toggleSelectAll = () => {
    setSelectedRowKeysDraftList((keys) =>
      keys.length === rowsDraftList.length ? [] : rowsDraftList.map((r) => r.key)
    );
  };

  const headerCheckbox = (
    <Checkbox
      checked={selectedRowKeysDraftList.length}
      indeterminate={
        selectedRowKeysDraftList.length > 0 && selectedRowKeysDraftList.length < rowsDraftList.length
      }
      onChange={toggleSelectAll}
    />
  );

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeysDraftList((keys) => [...keys, record.key]);
    } else {
      setSelectedRowKeysDraftList((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  useEffect(() => {
    stockAdjustment.getLimitFetchDays()
      .then((res) => {
        if (res.success) {
          setLimitDays(res.result);
        }
        else {
          message.error("Cannot get limit days");
        }
      })
      .catch((err) => {
        message.error("Cannot get limit days");
      })
  }, []);

  const disabledDate = (current) => {
    if (!creationDate) {
      return false;
    }
    const tooLate = creationDate[0] && current.diff(creationDate[0], 'days') >= limitDays;
    const tooEarly = creationDate[1] && creationDate[1].diff(current, 'days') >= limitDays;
    return !!tooEarly || !!tooLate;
  };

  const onOpenChange = (open) => {
    if (open) {
      setCreationDate([null, null]);
    }
  };

  const tbDraftListHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStockTakeListSearchText(selectedKeys[0]);
    setTbStockTakeListSearchedColumn(dataIndex);
  };

  const tbDraftListHandleReset = (clearFilters) => {
    clearFilters();
    setTbStockTakeListSearchText("");
  };

  const onActionDropDownChange = (selectedDropDown) => {
    if (selectedDropDown.label === "Edit") {
      const data = selectedDropDown.value.split("|")
      //showCModal(data[1]);
      editDraftFromList(data[1]);
    }
    else if (selectedDropDown.label === "Download") {
      const data = selectedDropDown.value.split("|")
      //showCModal(selectedDropDown.value.substring(1))
      downloadFileDraftList(data[1], data[2]);
    }
    else if (selectedDropDown.label === "Discard") {
      const data = selectedDropDown.value.split("|")
      //showCModal(selectedDropDown.value.substring(1))
      //showPopup(data[1]);
      onDiscardDraft(data[1]);
      //downloadFileDraftList(data[1], data[2]);
    }
  };

  const onDiscardDraft = (draftNumber) => {
    setIsLoadingTbDraftList(true);

    const dataToSubmit = {
      draftNumber: draftNumber
    };

    stockAdjustment
      .discardDraft(dataToSubmit)
      .then((res) => {
        if (res.success) {
          setRowsDraftList([...rowsDraftList.filter(q => q.draftNumber != dataToSubmit.draftNumber)]);

          notification.success({
            message: "Success",
            description: res.message,
            duration: 0,
          });

          setIsLoadingTbDraftList(false);
        } else {
          notification.error({
            message: "Failed",
            description: res.message,
            duration: 0,
          });

          setIsLoadingTbDraftList(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: "Internal server error. please contact administrator",
          duration: 0,
        });
        setIsLoadingTbDraftList(false);
      });
  };

  const onFinishFormDraftList = (values) => {
    const draftNumbersToSend = [];

    if (draftNumbersFetch.length === 0) {
      notification.warning({
        message: "Warning",
        description: "Please fetch data first",
      });

      return;
    }

    if (selectedRowKeysDraftList.length == 0) {
      notification.warning({
        message: "Warning",
        description: "Please choose draft number for submit",
      });

      return;
    }

    setIsLoadingTbDraftList(true);

    rowsDraftList.filter(x => selectedRowKeysDraftList.includes(x.key))
      .map((row, index) => {
        draftNumbersToSend.push(row.draftNumber);
      });

    const dataToSubmit = {
      //draftNumbers: selectedRowKeysDraftList
      draftNumbers: [... new Set(draftNumbersToSend)]
    };

    stockAdjustment
      .updateDraftAdjustment(dataToSubmit)
      .then((res) => {
        if (res.success) {
          setRowsDraftList([...rowsDraftList.filter(q => !dataToSubmit.draftNumbers.includes(q.draftNumber))]);

          notification.success({
            message: "Success",
            description: res.message,
            duration: 0,
          });

          setIsLoadingTbDraftList(false);
        } else {
          notification.error({
            message: "Failed",
            description: res.message,
            duration: 0,
          });

          setIsLoadingTbDraftList(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: "Internal server error. please contact administrator",
          duration: 0,
        });
        setIsLoadingTbDraftList(false);
      });
  }

  const onFetchData = (values) => {
    setIsLoadingTbDraftList(true);

    const dataToSubmit = {
      startTime: creationDate == null || creationDate[0] == null
        ? ""
        : creationDate[0].format(dateFormat),
      endTime: creationDate == null || creationDate[1] == null
        ? ""
        : creationDate[1].format(dateFormat),
      //status: values.status
    };

    // if (dataToSubmit.startTime == "" || dataToSubmit.endTime == "") {
    //   notification.error({
    //     message: "Error",
    //     description: "Creation date cannot be empty",
    //     duration: 0,
    //   });

    //   setIsLoadingTbDraftList(false);

    //   return;
    // }

    //calculate difference days, with today (+ 1)
    if (dataToSubmit.startTime != '') {

      const dateDiff = creationDate[1].diff(creationDate[0], 'days') + 1;

      if (dateDiff > limitDays) {
        notification.error({
          message: "Error",
          description: `Creation date range must ${limitDays} days`,
          duration: 0,
        });

        setIsLoadingTbDraftList(false);

        return;
      }
    }

    stockAdjustment
      .getDraftList(dataToSubmit.startTime, dataToSubmit.endTime)
      .then((res) => {
        if (res.success) {
          let newRows = [];
          let dataDraftNumbers = [];

          if (res.success) {
            res.result.sort(function (a, b) {
              return moment(b.creationTime).unix() - moment(a.creationTime).unix();
            });
            res.result.map((row, index) => {
              newRows.push({
                //key: index + 1,
                //key: row.draftNumber,
                key: row.id,
                index: index + 1,
                draftNumber: row.draftNumber,
                store: row.store,
                creatorUser: row.creatorUser,
                creationTime: util.formatNullableDatetime(row.creationTime)
              });

              if (!dataDraftNumbers.some(x => x == row.draftNumber)) {
                dataDraftNumbers.push(row.draftNumber);
              }
            });

            setRowsDraftList(newRows);
            setDraftNumbersFetch(dataDraftNumbers);
            //setSelectedRowKeysDraftList(newRows.map((item) => item.key));
          }

          setIsLoadingTbDraftList(false);
        }
        else {
          notification.error({
            message: "Error",
            description: res.message,
            duration: 0,
          });

          setIsLoadingTbDraftList(false);
        }
      })
      .catch((err) => {
        notification.error({
          message: "Internal server error. please contact administrator",
          duration: 0,
        });
        setIsLoadingTbDraftList(false);
      });
  };

  const onFinishFailedFormDraftList = (errorInfo) => {
    notification.error({
      message: "Failed to get data",
      duration: 0,
    });
    //console.log("Failed:", errorInfo);
  };

  const tbTakeListGetColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStockTakeListSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbDraftListHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbDraftListHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbDraftListHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStockTakeListSearchText(selectedKeys[0]);
              setTbStockTakeListSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    render: (text) =>
      tbUSListSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbUSListSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const downloadFileDraftList = (draftNumber) => {
    setIsLoading(true);
    let excelBlob;

    stockAdjustment
      .downloadFileDraft(draftNumber)
      .then((res) => {
        excelBlob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        });

        if (excelBlob == null || excelBlob.size == 0) {
          message.error("Failed to download result file");
        }
        else {
          let url = window.URL.createObjectURL(excelBlob);
          saveAs(url, `${draftNumber}_${moment().format("YYYY_MM_DD_HH:mm:ss")}.xlsx`);
        }

        setIsLoading(false);
      })
      .catch((err) => {
        util.displayApiError(err);
        setIsLoading(false);
      });
  };

  const columnsDraftList = [
    {
      title: "#",
      dataIndex: "index",
      width: 40,
      align: "center",
      sorter: (a, b) => a.index - b.index,
    },
    {
      title: "Draft Number",
      dataIndex: "draftNumber",
      ...tbTakeListGetColumnSearchProps("draftNumber"),
      sorter: (a, b) => a.draftNumber.localeCompare(b.draftNumber),
    },
    {
      title: "Store",
      dataIndex: "store",
      ...tbTakeListGetColumnSearchProps("store"),
      sorter: (a, b) => a.store - b.store,
    },
    {
      title: "Creator User",
      dataIndex: "creatorUser",
      ...tbTakeListGetColumnSearchProps("creatorUser"),
      sorter: (a, b) => a.creatorUser.localeCompare(b.creatorUser)
    },
    {
      title: "Creation Date",
      dataIndex: "creationTime",
      ...tbTakeListGetColumnSearchProps("creationTime"),
      sorter: (a, b) =>
        moment(a.creationTime).unix() - moment(b.creationTime).unix(),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   ...tbTakeListGetColumnSearchProps("status"),
    //   sorter: (a, b) => a.status.localeCompare(b.status),
    // },
    {
      title: "Action",
      render: (_, record) => (
        <Select
          labelInValue
          style={{ width: "100%" }}
          defaultValue={{ label: "Action", value: "default-selected" }}
          onChange={(selectedDropDown) => onActionDropDownChange(selectedDropDown)}
          value={{ label: "Action", value: "default-selected" }}
          options={[
            {
              value: 'E|' + record.draftNumber,
              label: 'Edit',
            },
            {
              //value: 'DO|' + record.key + '|' + record.token,
              value: 'DO|' + record.draftNumber,
              label: 'Download',
              //disabled: record.status == "Pending" //disabled when status pending, enabled when status done
            },
            {
              value: 'DI|' + record.draftNumber,
              label: 'Discard',
            },
            {
              value: '',
              label: 'Action',
              disabled: true,
              hidden: true
            },
          ]}
        >
          {/* <Option label="detail" value={record.key}>Detail</Option>
          <Option label="result" value={record.key}>Result</Option>
          <Option label="action" value="default-selected" disabled hidden>Action</Option> */}
        </Select>
      ),
    }
  ];

  return (
    <Spin tip="Loading..." size="large" spinning={isLoading}>
      <Row>
        <Col span={24}>
          <Form
            layout="vertical"
            form={formTakeList}
            onFinish={onFinishFormDraftList}
            initialValues={{
              creationDate: null,
              status: "ALL",
            }}
            onFinishFailed={onFinishFailedFormDraftList}
          >
            <Row gutter={10} align="bottom">
              <Col span={4}>
                <Form.Item
                  label="Creation Date"
                  name="creationTime"
                >
                  <RangePicker
                    style={{ width: "100%" }}
                    value={creationDate || dateValue}
                    disabledDate={disabledDate}
                    onCalendarChange={(val) => {
                      setCreationDate(val);
                    }}
                    onChange={(val) => {
                      setDateValue(val);
                    }}
                    onOpenChange={onOpenChange}
                    changeOnBlur
                  />
                </Form.Item>
              </Col>
              <Col span={2}>
                <Form.Item>
                  <Button
                    block
                    type="primary"
                    onClick={onFetchData}
                  //htmlType="submit"
                  >
                    Fetch
                  </Button>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="end" gutter={15}></Row>
            <Row>
              <Col>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={24}>
                <Table
                  size="small"
                  loading={isLoadingTbDraftList}
                  columns={columnsDraftList}
                  rowSelection={{
                    selectedRowKeys: selectedRowKeysDraftList,
                    type: "checkbox",
                    fixed: true,
                    onSelect: handleSelect,
                    columnTitle: headerCheckbox
                  }}
                  dataSource={rowsDraftList}
                  pagination={{ pageSize: 5 }}
                  bordered
                />
              </Col>
            </Row>
            <br />
            <Form.Item>
              <Button
                //icon={}
                //block 
                type="primary"
                size="large"
                htmlType="submit"
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
}
